import React, { useEffect } from "react"
import { Box } from "@chakra-ui/react"
import { XState } from "../../container/xstate"
import { User } from "../../container/user"
import { Wrapper, MotionBox, MotionVStack, MotionStack } from "./component"
import { Balance } from "./component/block/Balance"
import { Action } from "./component/block/Action"
import { Claim } from "./component/block/Claim"
import { Intro } from "./component/block/Intro"
import { Stake } from "./component/block/Stake"
import { UnStake } from "./component/block/UnStake"

const Staking = () => {
    const {
        state: { address },
    } = User.useContainer()
    const {
        state: current,
        actions: { xConnectWallet },
    } = XState.useContainer()

    useEffect(() => {
        if (current.matches("connectWallet") && address) {
            xConnectWallet()
        }
    }, [address, current, xConnectWallet])

    return (
        <Box bg="#E0E0E0" height="100vh">
            <Wrapper pt={[6, 20]} pb={20} px={[5, 20]} bg="#E0E0E0">
                <>
                    <MotionBox
                        overflow="hidden"
                        bg="#fcfcfc"
                        w={323}
                        boxShadow="0px 140px 80px rgba(0, 0, 0, 0.11),
    0px 58.4887px 33.4221px rgba(0, 0, 0, 0.079074),
    0px 31.2708px 17.869px rgba(0, 0, 0, 0.0655718),
    0px 17.5302px 10.0172px rgba(0, 0, 0, 0.055),
    0px 9.31014px 5.32008px rgba(0, 0, 0, 0.0444282),
    0px 3.87416px 2.21381px rgba(0, 0, 0, 0.030926)"
                        borderRadius={85}
                    >
                        <MotionStack w="100%">
                            {/* Outer Container */}
                            <MotionVStack
                                animate={{
                                    height: current.matches("home") ? 303 : 165,
                                }}
                                spacing={0}
                                flexGrow={1}
                                justify="flex-start"
                                overflow="hidden"
                                pb="30px"
                            >
                                <Balance />
                                <Action />
                            </MotionVStack>

                            {/* Claim */}
                            <Claim />

                            {/* Intro */}
                            {current.matches("connectWallet") && <Intro />}

                            {/* Staking Panel */}
                            {current.matches("stake") && <Stake />}

                            {/* Cooldown + Unstake */}
                            {current.matches("unstake") && <UnStake />}
                        </MotionStack>
                    </MotionBox>
                </>
            </Wrapper>
        </Box>
    )
}

export default Staking
